import { createEngagement } from '@services/youtube-platform.service';
import { character } from '@components/RunOfShow/defaultSelectionData';
export const handleEngagement = async ({ streamId, platformType, currentRosFeature, interactionId = null }) => {
  const startTime = Date.now();
  const sessionId = localStorage.getItem('sessionId');

  let payload = {
    interactionId,
    startTime,
    title: currentRosFeature.title,
    platformType,
    questionId: currentRosFeature.id,
    brandColours: currentRosFeature.color,
    settings: currentRosFeature.setting,
    sessionId
  };

  if (currentRosFeature.options) {
    payload = { ...payload, options: currentRosFeature.options };
  }

  if (currentRosFeature.type) {
    payload = { ...payload, type: currentRosFeature.type };
  }

  return await createEngagement(streamId, currentRosFeature.type, payload);
};

export const getOptionsName = (currentRosFeature, number) => {
  if (currentRosFeature.type !== 'pollWithOptions') {
    return number + 1;
  }

  if (currentRosFeature.setting.OptionsList === 'character') {
    return character(number);
  }

  return number + 1;
};

export const mapContinents = [
  {
    name: 'World',
    value: 'world',
    zoom: 1.5,
    coordinates: [29, 9.88],
    bounds: [[-180, -90], [180, 85]]
  },
  {
    name: 'Asia',
    value: 'asia',
    zoom: 2.5,
    coordinates: [110.878, 40.854],
    bounds: [[60, -5], [150, 70]]
  },
  {
    name: 'Africa',
    value: 'africa',
    zoom: 2.8,
    coordinates: [24.459, -2.079],
    bounds: [[-20, -40], [55, 40]]
  },
  {
    name: 'Australia',
    value: 'australia',
    zoom: 3.5,
    coordinates: [132.689, -24.196],
    bounds: [[110, -50], [155, -10]]
  },
  {
    name: 'Europe',
    value: 'europe',
    zoom: 3,
    coordinates: [20.087, 52.975],
    bounds: [[-15, 30], [40, 75]]
  },
  {
    name: 'North America',
    value: 'north-america',
    zoom: 2.8,
    coordinates: [-106.203, 52.494],
    bounds: [[-170, 15], [-50, 75]]
  },
  {
    name: 'South America',
    value: 'south-america',
    zoom: 2.8,
    coordinates: [-58.123, -25.491],
    bounds: [[-85, -65], [-30, 15]]
  }
]; export const parseColorToRgba = (color, alpha = 1) => {
  if (!color) return `rgba(0, 0, 0, ${alpha})`;

  // ---- GRADIENT: preserve it ----
  if (/gradient/i.test(color)) {
    if (alpha === 1) return color;

    return color.replace(
      /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*[\d.]+)?\s*\)/gi,
      (_, r, g, b) => `rgba(${r}, ${g}, ${b}, ${alpha})`
    );
  }

  const rgbMatch = color.match(
    /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i
  );

  if (rgbMatch) {
    const [, r, g, b] = rgbMatch;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  const hex = color.replace('#', '');
  if (hex.length === 3 || hex.length === 6) {
    const r =
      hex.length === 3
        ? parseInt(hex[0] + hex[0], 16)
        : parseInt(hex.slice(0, 2), 16);
    const g =
      hex.length === 3
        ? parseInt(hex[1] + hex[1], 16)
        : parseInt(hex.slice(2, 4), 16);
    const b =
      hex.length === 3
        ? parseInt(hex[2] + hex[2], 16)
        : parseInt(hex.slice(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgba(0, 0, 0, ${alpha})`;
};

export const mapSoundOptions = [
  { name: 'Pop', value: 'pop' },
  { name: 'Chime', value: 'chime' },
];

export const talkingTileSoundOptions = [
  { name: 'Soft Thud', value: 'soft_thud' },
  { name: 'Arcade', value: 'arcade' },
  { name: 'Whoosh', value: 'whoosh' },
  { name: 'Brick Fall', value: 'brick_fall' },

];

export const wheelSpinSoundOptions = [
  { name: 'Glass', value: 'glass' },
  { name: 'Tick', value: 'tick' },
];

export const wheelButtonSoundOptions = [
  { name: 'Button', value: 'button' },
  { name: 'Knob-button', value: 'knob-button' },
];

export const wheelResultSoundOptions = [
  { name: 'Fanfare', value: 'fanfare' },
  { name: 'Applause', value: 'applause' },
];

export const quizSoundOptions = [
  { name: 'A Christmas Dance', value: 'a_christmas_dance' },
  { name: 'Unfinished Stories', value: 'unfinished_stories' },
];

export const soundUrls = {
  pop: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_pop-on.mp3',
  chime: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_chime-on.mp3',
  whoosh: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_whoosh-on.mp3',
  soft_thud: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/soft-thud-talking-tiles.mp3',
  arcade: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/arcade-beep-talking-tiles.mp3'
};

export const featureSoundUrls = {
  map: {
    pop: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_pop-on.mp3',
    chime: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_chime-on.mp3'
  },
  talkingTiles: {
    whoosh: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/whoosh-talking-tile.mp3',
    brick_fall: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/brick-fall-talking-tiles.mp4',
    soft_thud: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/soft-thud-talking-tiles.mp3',
    arcade: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/arcade-beep-talking-tiles.mp3'
  },
  wheelSpin: {
    glass: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/glass.mp3',
    tick: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/tick.mp3',
  },
  wheelButton: {
    button: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/button.mp3',
    knob_button: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/knob-button.mp3',
  },
  wheelResult: {
    fanfare: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/fanfare.mp3',
    applause: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/applause.mp3',
  },
  quiz: {
    a_christmas_dance: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/A-Christmas-Dance.mp3',
    unfinished_stories: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/Unfinished-Stories.mp3'
  },
  theme: {
    light: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/switch-on.mp3',
    dark: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/switch-off.mp3'
  },
  onBoardingNext: {
    button: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/onboarding-sound.mp3',
  }
};

export const isStartable = (type) => !(['Quick Questions', 'PDF Slide', 'linkLibrary', 'textTrack', 'fantasticFans', 'blankScreen'].includes(type));
export const isTrackInteractions = (type) => ['Quick Questions', 'linkLibrary', 'textTrack', 'fantasticFans'].includes(type);
export const isSpinners = (type) => ['wheel', 'newWheel'].includes(type);
export const isPDFSlide = (type) => ['PDF Slide', 'blankScreen'].includes(type);
export const showSecondaryWorkflow = (type) => {
  return ![
    'wheel',
    'newWheel',
    'textTrack',
    'fantasticFans',
    'linkLibrary',
    'Quick Questions',
    'PDF Slide'
  ].includes(type);
};

export const SESSION_STORAGE_KEY = 'ACTIVE_SESSION_INFO';
